import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { RequirementSectionDataService } from "../../core/requirementsections.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";
import * as dataCore from "../../core/datacore";
import * as fileHelper from "../../shared/file.helper";
import { AuthServerProvider } from '../../shared/auth/auth.service';

@Component({
    selector: "crew-requirementsection",
    template: require('./requirement-section.component.html'),
    styles: [require('../../shared/nullable-date.css')]
})
export class RequirementSection extends DetailsBase<Nema.Crew.Model.CompetenceRequirementCollection, RequirementSectionDataService> {

    public ValidFrom: Date;
    public ExpirationDate: Date;

    public get checkValidFrom(): boolean {
        return !this.ValidFrom;
    }

    public get checkExpiration(): boolean {
        return !this.ExpirationDate;
    }

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('requirementSection') requirementSectionEntity: Nema.Crew.Model.CompetenceRequirementCollection,
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        @Inject("workplaces") public workplaces: Nema.Crew.Model.Workplace[],
        @Inject(RequirementSectionDataService.Id) requirementSectionDataService: RequirementSectionDataService,
        @Inject('authServerProvider') private authServerProvider: AuthServerProvider,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, requirementSectionEntity, requirementSectionDataService, $log);

        (<any>this.entity.CompetenceRequirementCollectionWorkplaces).load();

        this.ValidFrom = dataCore.addTimezoneOffset(this.entity.ValidFrom);
        this.ExpirationDate = dataCore.addTimezoneOffset(this.entity.Expiration);

        this.hasExistingFile = !!this.entity.AttachmentFileContentId;
    }

    public hasExistingFile: boolean;

    public entityName = "Requirement Section";

    public editStateName = "app.settings.requirementsections.edit";

    public listStateName = "app.settings.requirementsections";

    public downloadFile() {
        const jwtToken = this.authServerProvider.getToken();

        if (jwtToken) {
            window.open(fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id) + "?jwtToken=" + jwtToken);
        } else {
            window.open(fileHelper.getRequirementSectionFileDownloadUrl(this.entity.Id));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirementsections/requirement-section.component.ts